define('views/content/reseller_manager',['require','views/base/item_page_view','text!templates/content/reseller_manager.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');

    var temp = require("text!templates/content/reseller_manager.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-manager-page page',
        basePath: 'reseller-managers',
        titleKey: 'reseller_manager',

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'first_name': "required",
                    'last_name': "required",
                    'email': "required",
                    'phone_country': "required",
                    'phone_value': "required"
                },
                messages: {
                    'first_name': App.polyglot.t('manager_first_name_required'),
                    'last_name': App.polyglot.t('manager_last_name_required'),
                    'email': App.polyglot.t('manager_email_required'),
                    'phone_country': App.polyglot.t('manager_phone_country_required'),
                    'phone_value': App.polyglot.t('manager_phone_value_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        }
    });
});
